import { createContext } from 'react';
export const AccessoriesGalleryContext = createContext({
    galleryData: {
        imagesList: [],
        lightboxImagesList: [],
        lightboxThumbnails: [],
        thumbnailsList: [],
    },
    setGalleryData: () => ({}),
    currentId: '',
    setCurrentId: () => ({}),
});
